import { render, staticRenderFns } from "./MyFrontTable.vue?vue&type=template&id=5a7a854a&"
import script from "./MyFrontTable.vue?vue&type=script&lang=js&"
export * from "./MyFrontTable.vue?vue&type=script&lang=js&"
import style0 from "./MyFrontTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports